import * as React from 'react'
import clx from 'classnames'

import { DumpTruckIcon } from '@/app/features/icons/DumpTruck'

type Props = {
  title: string
  registrationNumber: string
  percent: number
  className?: string
}

export const VehicleUsageBox = ({
  title,
  registrationNumber,
  percent,
  className,
}:Props) => {
  const clampedPercent = Math.max(0, Math.min(percent, 100))

  
  return (
    <div
      className={clx(
        'tw-flex tw-flex-col tw-gap-2 tw-text-content-base/80',
        className,
      )}
    >
      <div className="tw-text-xs tw-font-medium">{title}</div>
      <div className="tw-h-1 tw-w-full tw-overflow-hidden tw-bg-secondary">
        <div
          className="tw-h-full tw-bg-primary tw-transition-all tw-duration-500"
          style={{
            width: `${clampedPercent}%`,
          }}
        />
      </div>

      <div className="tw-flex tw-items-center tw-text-xs">
        <span className="mr-2">
          <DumpTruckIcon className="tw-h-4 tw-w-4" />
        </span>
        <span>{registrationNumber}</span>
      </div>
      <div className="tw-text-base tw-font-bold tw-text-content-base">
        {clampedPercent}%
      </div>
    </div>
  )
}
